import React from 'react';
import '../template-file-css/document-file-template.css';


export const EDU_HealthReassessment = ({
    itemsRef,
    showErrorFor,
}) => {

    return (
        <form id='EDU_HealthReassessment' className='file-pdf-document'>
            <div className='file-template'>

                <p className='w-750'> <b> Health & Behavior Reassessment </b>
                </p>

                <table>
                    <tr>
                        <td className='w-250'> <span className='eleHeader'> Date of Birth: </span> </td>
                        <td className='w-250'> <span className='eleHeader'> Client's Age: </span> </td>
                        <td className='w-250'> <span className='eleHeader'> Place of Service Assessments: </span> </td>
                    </tr>
                    <tr>
                        <td className='w-250'> <input type='date' id='txtDateOfBirth' name='txtDateOfBirth' className='add-only' /> </td>
                        <td className='w-250'> <input type='text' id='txtClientAge' name='txtClientAge' className='add-only' /> </td>
                        <td className='w-250'> <input type='text' id='txtServiceAssessments' name='txtServiceAssessments' className='add-only' /> </td>
                    </tr>
                </table>

                <p className='w-750'>
                    <span className='eleHeader'> Special Problems </span>
                    Notate any special problems or issues the client is having.
                    <br />
                    <textarea id='txtSpecialProblems' name='txtSpecialProblems' className='add-only'> </textarea>
                </p>

                <table>
                    <tr>
                        <td className='w-750'> <span className='eleHeader'> Any current thoughts of suicide? </span> </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='radio' id='rbSuicide_Yes' name='rbSuicide' className='add-only' value='Yes' /> Yes &nbsp;
                            <input type='radio' id='rbSuicide_No' name='rbSuicide' className='add-only' value='No' /> No
                        </td>
                    </tr>
                </table>

                <p className='w-750'>
                    <span className='eleHeader'> If Yes, please describe: </span>
                    <textarea id='txtPleaseDescribe_1' name='txtPleaseDescribe_1' className='add-only'> </textarea>
                </p>

                <table>
                    <tr>
                        <td className='w-750'> <span className='eleHeader'> Any current thoughts of self-mutilation? </span> </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='radio' id='rbSelfMutilation_Yes' name='rbSelfMutilation' className='add-only' value='Yes' /> Yes &nbsp;
                            <input type='radio' id='rbSelfMutilation_No' name='rbSelfMutilation' className='add-only' value='No' /> No
                        </td>
                    </tr>
                </table>

                <p className='w-750'>
                    <span className='eleHeader'> If Yes, please describe: </span>
                    <textarea id='txtPleaseDescribe_2' name='txtPleaseDescribe_2' className='add-only'> </textarea>
                </p>

                <table>
                    <tr>
                        <td className='w-750'> <span className='eleHeader'> Any safety contacts within the last 30 days? </span> </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='radio' id='rbSafetyContacts_Yes' name='rbSafetyContacts' className='add-only' value='Yes' /> Yes &nbsp;
                            <input type='radio' id='rbSafetyContacts_No' name='rbSafetyContacts' className='add-only' value='No' /> No
                        </td>
                    </tr>
                </table>

                <p className='w-750'>
                    <span className='eleHeader'> If Yes, please describe: </span>
                    <textarea id='txtPleaseDescribe_3' name='txtPleaseDescribe_3' className='add-only'> </textarea>
                </p>

                <table>
                    <tr>
                        <td className='w-750'> <span className='eleHeader'> Any acts of aggression to others or property within the last 30 days? </span> </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='radio' id='rbAggression_Yes' name='rbAggression' className='add-only' value='Yes' /> Yes &nbsp;
                            <input type='radio' id='rbAggression_No' name='rbAggression' className='add-only' value='No' /> No
                        </td>
                    </tr>
                </table>

                <p className='w-750'>
                    <span className='eleHeader'> If Yes, please describe: </span>
                    <textarea id='txtPleaseDescribe_4' name='txtPleaseDescribe_4' className='add-only'> </textarea>
                </p>

                <table>
                    <tr>
                        <td className='w-750'> <span className='eleHeader'> Any current thoughts of harming others? </span> </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='radio' id='rbHarmingOthers_Yes' name='rbHarmingOthers' className='add-only' value='Yes' /> Yes &nbsp;
                            <input type='radio' id='rbHarmingOthers_No' name='rbHarmingOthers' className='add-only' value='No' /> No
                        </td>
                    </tr>
                </table>

                <p className='w-750'>
                    <span className='eleHeader'> If Yes, please describe: </span>
                    <textarea id='txtPleaseDescribe_5' name='txtPleaseDescribe_5' className='add-only'> </textarea>
                </p>

                <table>
                    <tr>
                        <td className='w-750'> <span className='eleHeader'> Any episodes of seclusion or restraint within the last 30 days? </span> </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='radio' id='rbRestraint_Yes' name='rbRestraint' className='add-only' value='Yes' /> Yes &nbsp;
                            <input type='radio' id='rbRestraint_No' name='rbRestraint' className='add-only' value='No' /> No
                        </td>
                    </tr>
                </table>

                <p className='w-750'>
                    <span className='eleHeader'> If Yes, please describe: </span>
                    <textarea id='txtPleaseDescribe_6' name='txtPleaseDescribe_6' className='add-only'> </textarea>
                </p>


            </div>
        </form>

    )
}